import SkillForm from "../Components/Skills/SkillForm";

const SkillFormPage = () => {
  return (
    <div>
      <SkillForm />
    </div>
  );
};

export default SkillFormPage;
